import { create } from 'zustand';

import { FilterForm } from '@/pages/externals/mos-pos-resend/service';

/**
 * POS連携再送信一覧で確定した検索条件とページ位置です。
 * 確認画面から一覧へ戻ったときに復元するため、画面の外で保持します。
 * サイドバーなど他の経路から一覧を開き直したときも復元し、初期値に戻るのは
 * ページを再読み込みしたときだけです。
 */
interface MosPosResendListState {
  /** null は未検索 (画面の既定条件を使う) */
  applied: FilterForm | null;
  page: number;
  setApplied: (applied: FilterForm) => void;
  setPage: (page: number) => void;
  reset: () => void;
}

export const useMosPosResendListState = create<MosPosResendListState>(
  (set) => ({
    applied: null,
    page: 1,
    setApplied: (applied) => set({ applied }),
    setPage: (page) => set({ page }),
    reset: () => set({ applied: null, page: 1 }),
  })
);
